import { Alert, TextButton } from '@zillow/constellation-10';

export const FairHousingAlert = () => (
  <Alert tone="critical" css={{ marginBottom: 'md' }}>
    Custom flag, Subheader, Custom details or Facebook/Instagram ad copy does not meet our{' '}
    <TextButton asChild>
      <a
        href="https://www.zillow.com/rental-manager/resources/fair-housing-guide/"
        target="_blank"
        rel="noopener noreferrer"
      >
        fair housing requirements
      </a>
    </TextButton>
    .
  </Alert>
);
